import { createContext, useContext } from "react";

interface AuthenticationContextProps {
  logout: () => Promise<void>;
  userEmail: string | null;
}

const AuthenticationContext = createContext<AuthenticationContextProps | undefined>(undefined);

export const useAuthentication = (): AuthenticationContextProps => {
  const context = useContext(AuthenticationContext);
  if (!context) {
    throw new Error("'useAuthentication' must be used within the Authentication Provider");
  }
  return context;
};

export { AuthenticationContext };
